import * as Services from '../services';
import { transformFiles } from '../helper';

export default {
  /**
   *
   * @param files
   * @param context
   * @returns {Promise<*>}
   */
  async merchantFileUploads(context, { files }) {
    console.log(files)
    // Loop over files to create individual API calls
    const formData = new FormData();
    const fileNames = Object.keys(files);

    for (let index = 0; index < fileNames.length; index += 1) {
      const fileName = fileNames[index];
      const file = files[fileName];
      formData.append('name', fileName);
      formData.append('data', file);

      await Services.uploadMerchantFiles(formData);
    }
  },

  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchUploadedFiles({ commit }) {
    const response = await Services.getUploadedFile();
    if (Array.isArray(response.data)) {
      commit('setProperty', { property: 'files', payload: transformFiles(response) });
    }
  },
};
